export const CISCO_SD_WAN_CONSTANTS = {
  Hero_desc: [
    "CloudMyLab Offers a Fully Built Cisco SDWAN On-demand Lab Infrastructure with the latest software and licensing.",
    "Cisco SD-WAN is a software-defined approach to managing the WAN. Key advantages include: Reducing costs with transport independence across MPLS, 4G/5G LTE, and other connection types. SD-WAN is a huge Leg-up over traditional WAN, it’s the new way to consume WAN technologies given the need for bandwidth and application traffic today.",
  ],
  Hero_points: [
    "Our SD-WAN Lab has been designed on Vmware and EVE-NG with a fairly open topology which can be purposed for any POC or Certification Labs.",
    "We currently offer 4 Fully Built POD at this time and Labs can be reserved in blocks of 7 Days.",
  ],
};

export const CISCO_SD_WAN_HW_LIST = [
  "Viptela 20.6.1",
  "20 X vEdges ( Can be Repurposed)",
  "10 X cEDges ( Can be Repurposed)",
  "1 X vBond",
  "1 x vManage",
  "2 x vSmart",
  "1 X jumpHost",
  "1 X CA Server",
];

export const CISCO_SD_WAN_FAQ_LIST = [
  {
    title: "Do you sell/Provide workbooks with Cisco  SD-WAN LABS ?",
    content:
      "No, but we do provide detailed  Sample Labs/Configuration Examples and you can use our labs with any vendor labs.  You can check the documentation Section, we partner with Industry’s top consultants to build those samples.",
  },
  {
    title: "Do you offer  Training for the Learning Labs ?",
    content:
      "CloudMyLab is an Infrastructure Provider and we do not offer any  Virtual or In-person Training, However, we will be happy to connect you with our awesome training Partners Patriot Solutions and Training world 360.",
  },
  {
    title: "Are these Labs locked to a certain configurations only ?",
    content:
      "In this LAB, vManage, vSmart, vBond ( Control Plane)  is pre-configured from the Licensing Perspective. No Policy configuration or other configuration has been performed.  You can feel free to change things around, upload/Create your own virtual machines and tie it back to the Lab.",
  },
  {
    title: "What does 5 Days access Mean ?",
    content:
      "5 Day Access Means that you will have access to the Lab for 5 Calendar Days 24X5.",
  },
  {
    title:
      "I am stuck and need help configuring SD-WAN or need a consult on an integration, can you guys Help ?",
    content:
      "Yes, we can engage our Professional Services Team.  As a general rule, our Level 1 support team is not equipped to troubleshoot specific scenarios built by you.",
  },
  {
    title: "So what does your Level 1 Support do ?",
    content:
      "Our Level 1 Support will ensure that your Lab infrastructure and underlying automation is in perfect condition, so you can do what you like.",
  },
  {
    title: "What can I accomplish on your Lab Infrastructure with SD-WAN ?",
    content:
      "You could use our Sample Labs to get started and you can build on top of it. All the Features are supported as listed out the software release of the version.",
  },
  {
    title: "What if I need additional Hardware or software ?",
    content:
      "The Learning Labs are general purpose labs and you can attach anything virtual by using the UCS in the lab environment, for additional Hardware , please utilize our POC-AS-A-Service or LAB-As-A Service.",
  },
];

export const CISCO_SD_WAN_PRICING_CARD_LIST = [
  "Latest Software",
  "Pre-Configured Control Plane",
  "Fully Licensed",
  "20 X vEdges",
  "1 X Jump Box",
  "Console Access",
  "5 Days Dedicated Access",
];
